import { Form, Link, useActionData, useNavigation } from "react-router-dom";

type HelpSource = {
    id: number | string | null;
    source: string;
    sourceKey: string;
    title: string;
    summary: string;
    url: string;
};

type HelpResponse = {
    answer: string;
    sources: HelpSource[];
    usedLLM: boolean;
};

const sourceOptions = [
    ["all", "All data"],
    ["users", "Users"],
    ["leads", "Leads"],
    ["organizations", "Organizations"],
    ["contacts", "Contacts"],
    ["projects", "Projects"],
    ["opportunities", "Opportunities"],
    ["proposals", "Proposals"],
    ["works", "Works"],
];

export default function Help() {
    const data = useActionData() as HelpResponse | null;
    const navigation = useNavigation();
    const loading = navigation.state !== "idle";

    return (
        <div className="cssContent pb8rem">
            <h3 className="mt-3">Help</h3>
            <Form method="post" className="border rounded p-3 mt-3">
                <label className="form-label" htmlFor="helpSource">Data source</label>
                <select id="helpSource" name="source" className="form-select mb-3" defaultValue="all">
                    {sourceOptions.map(([value, label]) => (
                        <option key={value} value={value}>{label}</option>
                    ))}
                </select>
                <label className="form-label" htmlFor="helpQuestion">Request</label>
                <textarea
                    id="helpQuestion"
                    name="question"
                    className="form-control"
                    rows={7}
                    placeholder="Ask about leads, organizations, contacts, projects, opportunities, proposals, or works..."
                    required
                />
                <button className="btn btn-outline-primary mt-3" disabled={loading} type="submit">
                    {loading ? "Thinking..." : "Ask"}
                </button>
            </Form>
            <div className="border rounded p-3 mt-3">
                <h5>Output</h5>
                {data?.answer ? (
                    <pre className="mb-0" style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>
                        {data.answer}
                    </pre>
                ) : (
                    <div className="cssLoading">Ask a question to generate an answer from the selected data source.</div>
                )}
            </div>
            {data?.sources?.length ? (
                <div className="border rounded p-3 mt-3">
                    <div className="d-flex align-items-center mb-2">
                        <h5 className="mb-0">Sources</h5>
                        <span className="text-muted ms-3">
                            {data.usedLLM ? "Generated with LLPhant" : "Database retrieval"}
                        </span>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>Source</th>
                                    <th>Record</th>
                                    <th>Summary</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.sources.map((source, key) => (
                                    <tr key={`${source.sourceKey}-${source.id}-${key}`}>
                                        <td>{source.source}</td>
                                        <td>
                                            {source.id ? (
                                                <Link to={source.url}>{source.title || `#${source.id}`}</Link>
                                            ) : (
                                                source.title
                                            )}
                                        </td>
                                        <td>{source.summary}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : null}
        </div>
    );
}
